export default {"src":"/_next/static/media/BK.b71e45e6.svg","height":18,"width":18};